import smoothscroll from 'smoothscroll-polyfill';
import { CFG } from './config';
import {
  Menu,
  Accordion,
  AnchorScroll
} from './_main';

// home
import {
  VisualSlides,
  MembersScrollTrigger,
  // MembersSlides,
  // AutoMovingSlides,
  // MagazineSlides,
  // AreaSlides,
  // FilteringCategories,
  // ViewMore
} from './_home'

// works
import {
  AutoMovingSlides,
} from './_works'

// education
import {
  ScrollerHint,
} from './_education'

// members
import {
  OtherMembersSlides,
} from './_members'

{
  smoothscroll.polyfill();

  const domMenu = document.querySelector('[data-js="trigger"]');
  if (domMenu) new Menu(domMenu);

  const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
  if ( domAnchorScroll ) {
    domAnchorScroll.forEach(el => {
      new AnchorScroll(el);
    });
  }

  const domAccordion = document.querySelectorAll('[data-js="accordion"]');
  if (domAccordion) {
    [...domAccordion].forEach(el=>{
      new Accordion(el);
    });
  }
}

  
const domVisualSlides = document.querySelector('[data-js="visual"]');
if (domVisualSlides) new VisualSlides(domVisualSlides);

// home
{
  const domMembersScrollTrigger = document.querySelector('[data-js="members-trigger"]');
  if (domMembersScrollTrigger) new MembersScrollTrigger(domMembersScrollTrigger);
}

// works
{
  const domAutoMovingSlides = document.querySelectorAll('[data-js="auto-slider"]');
  if (domAutoMovingSlides) {
    [...domAutoMovingSlides].forEach(el=>{
      new AutoMovingSlides(el);
    })
  }
}

// education
{
  const domScrollerHint = document.querySelector('[data-js="scroll-hint"]');
  if (domScrollerHint) new ScrollerHint(domScrollerHint);
}

// members
{
  const domOtherMembersSlides = document.querySelector('[data-js="other-members-slide"]');
  if (domOtherMembersSlides) new OtherMembersSlides(domOtherMembersSlides);
}

// const domMagazineSlides = document.querySelector('[data-js="magazine-slide"]');
// if (domMagazineSlides) new MagazineSlides(domMagazineSlides);

// const domAreaSlides = document.querySelectorAll('[data-js="area-slide"]');
// if (domAreaSlides) {
//     [...domAreaSlides].forEach(el=>{
//         new AreaSlides(el);
//     });
// }

// // フィルタリング機能
// const domFilteringCategories = document.querySelector('[data-js="conditions-categories"]');
// if ( domFilteringCategories ) new FilteringCategories(domFilteringCategories);

// const domViewMoreEvent = document.querySelector('[data-js="event"]');
// if (domViewMoreEvent) new ViewMore(domViewMoreEvent);
// const domViewMoreNews = document.querySelector('[data-js="news"]');
// if (domViewMoreNews) new ViewMore(domViewMoreNews);
